import React from "react";

// Recovers from DOM-desync crashes (e.g. browser auto-translate rewriting React-managed text nodes → removeChild NotFoundError).
export default class AppErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) {
    const msg = String(error?.message || "");
    try {
      let user = "";
      try { user = JSON.parse(localStorage.getItem("mf_user") || "null")?.email || ""; } catch { /* noop */ }
      fetch(`${process.env.REACT_APP_BACKEND_URL}/api/client-errors`, {
        method: "POST", headers: { "Content-Type": "application/json" }, keepalive: true,
        body: JSON.stringify({ message: msg, stack: `${String(error?.stack || "").slice(0, 800)}\n${String(info?.componentStack || "").slice(0, 600)}`, page: window.location.pathname + window.location.search, user, lang: navigator.language, viewport: `${window.innerWidth}x${window.innerHeight}` }),
      }).catch(() => {});
    } catch { /* noop */ }
    if (/removeChild|insertBefore|not a child of this node/i.test(msg) && !sessionStorage.getItem("mf_dom_recovered")) {
      sessionStorage.setItem("mf_dom_recovered", "1");
      window.location.reload();
    }
  }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="min-h-screen bg-background text-foreground flex items-center justify-center p-8" data-testid="app-error-boundary">
        <div className="max-w-md space-y-4 text-center">
          <h1 className="font-display text-2xl font-bold">Oups, un problème d'affichage</h1>
          <p className="text-sm text-muted-foreground">Si votre navigateur traduit automatiquement la page, désactivez la traduction pour ce site (l'interface est déjà en français), puis rechargez.</p>
          <button type="button" onClick={() => { sessionStorage.removeItem("mf_dom_recovered"); window.location.reload(); }} className="rounded-md bg-primary text-primary-foreground px-4 py-2 text-sm font-medium" data-testid="app-error-reload">Recharger</button>
        </div>
      </div>
    );
  }
}
